import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastController } from '@ionic/angular';

import { AlertInfo, AlertTypes } from '../../interfaces/alert.model';
import { AlertService } from '../../providers/alert.service';

@Component({
  selector: 'app-alert',
  template: ''
})
export class AlertComponent implements OnInit, OnDestroy {
  private sub: Subscription;
  constructor(private notificationSvc: AlertService, private toastController: ToastController) { }

  ngOnInit() {
    this.sub = this.notificationSvc.alert$.subscribe(alert => this.showAlert(alert));
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  // --------------------------------------------
  private async showAlert(alert: AlertInfo) {
    if (!alert || !alert.text) { return; }
    console.log(alert.text);

    let color = 'success';

    switch (alert.type) {
      case AlertTypes.Info:
        color = 'tertiary';
        break;

      case AlertTypes.Warn:
        color = 'warning';
        break;

      case AlertTypes.Error:
        color = 'danger';
        break;
    }

    const toast = await this.toastController.create({
      message: alert.icon+"   "+alert.text,
      position: "top",
      cssClass: "custom-toast-class-error",
      duration: alert.duration,
    });

    toast.present();
    
  }
}
